import { toast } from "react-toastify";
import instance from "../Config/Config";


export const remove_account_url = "remove-account"


const logout =()=>{
    localStorage.removeItem("authToken"); 
    toast.success("Logout Successfull !")
}


export const remove_account = async(id)=>{
    const response = await instance.delete(`${remove_account_url}/${id}`)
    return response.data
}